<template>
  <div>
    <div v-for="(field, index) in _fields" :key="`${field.fieldForm._id}-${index}`">
      <div class="accordion" role="tablist">
        <div no-body class="mb-1 condition-main">
          <div header-tag="header" class="p-1 competition-accordion-header" role="tab">
            <b-link class="competition-accordion-button" v-b-toggle="getCollapseId(field)">
              <ChevronUpIcon class="competition-accordion-icon" />
              <p class="accordion-header-title">{{ field.fieldForm.title }}</p>
            </b-link>
            <span v-if="onDelete !== undefined" @click="onDeleteClicked(field.fieldForm.field)" class="delete-field">
              <delete-field />
            </span>
          </div>
          <b-collapse :id="getCollapseId(field)" role="tabpanel">
            <div class="condition-body">
              <SpecialFinanceDataField
                v-if="isSpecialFinanceDataField(field.fieldForm.field) && field.conditions !== null"
                :getFieldFormErrors="getFieldFormErrors"
                :field="field"
                :onChanged="onChanged"
                :onDelete="onDelete ? onDeleteClicked : undefined"
              >
              </SpecialFinanceDataField>
              <SpecialAnnualDataField
                v-else-if="isSpecialAnnualDataField(field.fieldForm.field) && field.conditions !== null"
                :getFieldFormErrors="getFieldFormErrors"
                :field="field"
                :onChanged="onChanged"
                :onDelete="onDelete ? onDeleteClicked : undefined"
              >
              </SpecialAnnualDataField>
              <div v-else>
                <number-field
                  v-if="field.fieldForm.type.mainType === companyFieldType.NUMBER && field.conditions !== null"
                  :getFieldFormErrors="getFieldFormErrors"
                  :field="field"
                  :onChanged="onChanged"
                  :onDelete="onDelete ? onDeleteClicked : undefined"
                ></number-field>
                <array-field
                  v-if="field.fieldForm.type.mainType === companyFieldType.ARRAY && field.conditions !== null"
                  :getFieldFormErrors="getFieldFormErrors"
                  :field="field"
                  :onChanged="onChanged"
                  :onDelete="onDelete ? onDeleteClicked : undefined"
                >
                </array-field>
                <boolean-field
                  v-if="field.fieldForm.type.mainType === companyFieldType.BOOLEAN && field.conditions !== null"
                  :getFieldFormErrors="getFieldFormErrors"
                  :field="field"
                  :onChanged="onChanged"
                  :onDelete="onDelete ? onDeleteClicked : undefined"
                >
                </boolean-field>
              </div>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { COMPETITION_FIELD_TYPE, COMPETITION_SPECIAL_FILTER } from '../../models/competitionFieldType'
import NumberField from './NumberField.vue'
import SpecialFinanceDataField from './SpecialFinanceDataField.vue'
import SpecialAnnualDataField from './SpecialAnnualDataField.vue'
import ArrayField from './ArrayField.vue'
import BooleanField from './BooleanField.vue'
import ChevronUpIcon from 'vue-material-design-icons/ChevronUp.vue'
import DeleteField from './DeleteField.vue'
export default {
  name: 'CompanyFields',
  components: {
    ChevronUpIcon,
    SpecialAnnualDataField,
    SpecialFinanceDataField,
    NumberField,
    ArrayField,
    BooleanField,
    DeleteField
  },
  props: ['onChanged', 'getFieldFormErrors', 'fields', 'onDelete', 'collapseId'],
  data: function() {
    return { loading: true, companyFieldType: COMPETITION_FIELD_TYPE }
  },
  computed: {
    _fields: function() {
      const filteredFields = []
      Object.keys(this.fields).forEach(key => {
        if (this.fields[key].conditions !== null) {
          filteredFields.push(this.fields[key])
        }
      })
      return filteredFields
    }
  },
  methods: {
    getCollapseId: function(field) {
      if (this.collapseId === undefined) {
        return `competition-accordion-${field.fieldForm._id}`
      } else {
        return `competition-accordion-${field.fieldForm._id}-${this.collapseId}`
      }
    },
    onDeleteClicked: function(index) {
      const newValues = { ...this.fields }
      newValues[index].conditions = null
      this.$emit('onChanged', newValues)
    },
    isSpecialFinanceDataField: function(field) {
      return COMPETITION_SPECIAL_FILTER.SPECIAL_FINANCE_DATA_FIELDS.includes(field)
    },
    isSpecialAnnualDataField: function(field) {
      return COMPETITION_SPECIAL_FILTER.SPECIAL_ANNUAL_DATA_FIELDS.includes(field)
    }
  },
  async mounted() {
    Object.keys(this.fields).map(key => {
      const field = this.fields[key]
      if (field.conditions !== null && field.conditions.length > 0) {
        this.$root.$emit('bv::toggle::collapse', this.getCollapseId(field))
      }
    })
  }
}
</script>
<style>
@import './styles.scss';

.delete-field {
  color: red;
  display: inline;
  float: left;
  margin-left: 15px;
}
.delete-field:hover {
  cursor: pointer;
  color: sienna;
}
</style>
